import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Icon } from "@chakra-ui/react";
export const EthereumIcon = memo((props) => (_jsx(Icon, { viewBox: "0 0 24 24", ...props, children: _jsx("path", { d: "M16.7469 12.15L12 15.05L7.25 12.15L12 4L16.7469 12.15ZM12 15.9812L7.25 13.0813L12 20L16.75 13.0813L12 15.9812Z", fill: "currentColor" }) })));
//# sourceMappingURL=Ethereum.js.map